"use client";

import { cn } from "@scott/ui/client";
import type { FC } from "react";
import type { EcommerceBarData } from "../../../types/header";

export interface EcommerceBarProps {
  className?: string;
  slotsData: EcommerceBarData;
}

const EcommerceBarLink = ({ text, link }: { text: string; link?: string }) => {
  const className =
    "text-ecommerce-bar-text hover:text-ecommerce-bar-text-hover";
  return link ? (
    <a className={className} href={link}>
      {text}
    </a>
  ) : (
    <span className={className}>{text}</span>
  );
};

const EcommerceBar: FC<EcommerceBarProps> = ({ className, slotsData }) => {
  const commonClasses =
    "font-nav-heading uppercase py-2 flex-1 tracking-wide text-xs font-bold";

  return (
    <header className="bg-ecommerce-bar font-nav-heading">
      <div className={cn("container flex gap-0", className)}>
        <div
          className={cn(
            commonClasses,
            "basis-1/3 justify-center text-center md:justify-start md:text-left"
          )}
        >
          <EcommerceBarLink
            link={slotsData.leftLink}
            text={slotsData.leftText}
          />
        </div>
        <div
          className={cn(
            commonClasses,
            "hidden justify-center text-center md:flex md:basis-1/3"
          )}
        >
          <EcommerceBarLink
            link={slotsData.centerLink}
            text={slotsData.centerText}
          />
        </div>
        <div
          className={cn(
            commonClasses,
            "hidden justify-end text-right md:flex md:basis-1/3"
          )}
        >
          <EcommerceBarLink
            link={slotsData.rightLink}
            text={slotsData.rightText}
          />
        </div>
      </div>
    </header>
  );
};

EcommerceBar.displayName = "EcommerceBar";

export { EcommerceBar };
